module.exports = __webpack_public_path__ + "img/get-app-th.6faaa15.png";